import {Routes, Route, Navigate} from 'react-router-dom'
import Home from './pages/Home'
import Configuration from './pages/Configuration.jsx'
import Login from './pages/Login'
import Members from './pages/Members'
import NavBarFunc from './components/Navbar'
import Footer from './components/Footer'
import ProtectedRoute from './components/ProtectedRoute'
import Download from './pages/Download'
import Rewards from './pages/Rewards'
import Tokenomics from './pages/Tokenomics'
import Data from './pages/Data'
import News from './pages/News'
import Container from "react-bootstrap/esm/Container"
import Changepassword from './pages/Changepassword'

export default function App() {
  return (
    <div className="bg-dark text-white">
      <NavBarFunc/>
      <div className="main-container">
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/tokenomics" element={<Tokenomics/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/configuration" element={<Configuration/>}/>
          <Route path="/download" element={<Download/>}/>
          <Route path="/rewards" element={<Rewards/>}/>
          <Route path="/data" element={<Data/>}/>
          <Route path="/news" element={<News/>}/>
          <Route path="/members" element={
            <ProtectedRoute>
              <Members/>
            </ProtectedRoute>
          }/>
          <Route path="/changepw" element={
            // <ProtectedRoute>
            <Changepassword/>
            // </ProtectedRoute>
          }/>
          <Route path="/*" element={<Navigate to="/"/>}/>
        </Routes>
      </div>
      <Footer/>
    </div>
  )
}
